import React from "react";
import { FeatureGrid } from "./FeatureGrid";
import { useScrollReveal } from "./useScrollReveal";

interface FeatureShowcaseProps {
	badge: string;
	title: string;
	description: string;
	mockup: React.ReactNode;
	features: Array<{
		icon: React.ReactNode;
		title: string;
		description: string;
	}>;
	reversed?: boolean;
}

export function FeatureShowcase({
	badge,
	title,
	description,
	mockup,
	features,
	reversed = false,
}: FeatureShowcaseProps) {
	const ref = useScrollReveal();

	return (
		<div ref={ref} className="py-20 md:py-28">
			<div
				className={`flex flex-col gap-12 lg:flex-row lg:items-center lg:gap-16 ${
					reversed ? "lg:flex-row-reverse" : ""
				}`}
			>
				{/* Text */}
				<div className="flex-1">
					<span className="scroll-reveal mb-4 inline-block rounded-full border border-[#db241e]/20 bg-[#db241e]/5 px-3 py-1 text-xs font-medium text-[#db241e]">
						{badge}
					</span>
					<h2 className="scroll-reveal text-3xl font-bold tracking-tight text-white md:text-4xl">
						{title}
					</h2>
					<p className="scroll-reveal mt-4 text-lg leading-relaxed text-zinc-400">
						{description}
					</p>
					<FeatureGrid features={features} />
				</div>

				{/* Mockup */}
				<div className="scroll-reveal flex-1" style={{ transitionDelay: "200ms" }}>
					{mockup}
				</div>
			</div>
		</div>
	);
}
